import classes from "./pagination.module.scss";

import { Col, Row } from "react-bootstrap";

import { formatMiles } from "@/services/Utils";

const NewPagination = (props) => {
	const { page, setPage, last_page, from, to, quantity } = props;

	const handlePaginate = (value) => {
		if (value && last_page > page) {
			setPage(page + 1);
		}

		if (!value && page !== 1) {
			setPage(page - 1);
		}
	};

	return (
		<Row className={classes.paginatorRow} style={{ alignItems: "center", justifyContent: "center" }}>
			<Col xs={2} md={2} className={`${classes.arrow} ${classes.preview}`} onClick={() => handlePaginate(false)}></Col>
			<Col xs={8} md={8} className={classes.label}>
				<span>
					{from ? formatMiles(from) : 0}-{to ? formatMiles(to) : 0}
				</span>
				{" de "}
				{quantity ? formatMiles(quantity) : 0}
			</Col>
			<Col xs={2} md={2} className={`${classes.arrow} ${classes.next}`} onClick={() => handlePaginate(true)}></Col>
		</Row>
	);
};

export default NewPagination;
